var map = {
	"./bg_auido_cover.png": "205a",
	"./bg_pdf_cover.png": "7ca0",
	"./bg_ppt_cover.png": "d888",
	"./bg_text_cover.png": "fa52",
	"./bg_word_cover.png": "38e4",
	"./bg_xlsx_cover.png": "a3a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd0c";